import { render, staticRenderFns } from "./DictionaryCharacteristicEffects.vue?vue&type=template&id=0242a10a&scoped=true&"
import script from "./DictionaryCharacteristicEffects.vue?vue&type=script&lang=js&"
export * from "./DictionaryCharacteristicEffects.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryCharacteristicEffects.vue?vue&type=style&index=0&id=0242a10a&scoped=true&lang=scss&"
import style1 from "./DictionaryCharacteristicEffects.vue?vue&type=style&index=1&id=0242a10a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0242a10a",
  null
  
)

export default component.exports